// extracted by mini-css-extract-plugin
export var active = "_jl-2";
export var recordingDot = "_jl-1";
export var recordingIndicator = "_jl-0";